import { logErrorToDatadog } from '../../common/utils'
import { SubjectResponse, SubjectSummaryResponse } from './types'

const API_URL = process.env.VUE_APP_BASE_URL

export const getSubjectSummary = async (
  token: string,
): Promise<SubjectSummaryResponse | undefined> => {
  try {
    const response = await fetch(`${API_URL}/subject/summary`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return response.json()
  } catch (e) {
    console.error(e)
    logErrorToDatadog('Error getting subject progress', {}, e as Error)
  }
}

export const getSubject = async (token: string): Promise<SubjectResponse | undefined> => {
  try {
    const response = await fetch(`${API_URL}/subject`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })

    return response.json()
  } catch (e) {
    logErrorToDatadog('Error getting subject', { token }, e as Error)
  }
}
